import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useGetListEmployee } from "./useEmployee";
import { PER_PAGE_DEFAULT_EMPLOYEES, STATUS_WORKING } from "constants";
import { useEmployeeStore } from "../store/employeeStore";
import { filterOnlyEnableEmployee } from "utils";
import { useLoading } from "context/LoadingContext";

const useSearchEmployee = (
  metadata = {
    is_open: false,
  },
  setValue = null
) => {
  const { startLoading, stopLoading } = useLoading();
  const isOpen = useMemo(() => !!metadata?.is_open, [metadata?.is_open]);
  const { mutateAsync: triggerGetEmployees } = useGetListEmployee();
  const {
    searchedEmployees,
    paramsListEmployee,
    pagination,
    allEmployees,
  } = useEmployeeStore((state) => state);
  const {
    setIsLoading,
    setAllEmployees: setStoreAllEmployees,
    setSearchedEmployees: setStoreSearchedEmployees,
    setPagination,
    setParamsListEmployee,
    setTotalSearchedEmployees,
    setIsShowSearchData,
    setSelectedEmployeeIds,
  } = useEmployeeStore();

  // when user trigger checkbox 全社員必須受講  (select all employee)
  // Set all id employee to selectedEmployeeIds (use for textare in course detail page)
  const handleSelectAllEmployee = (isCheckAll) => {
    setSelectedEmployeeIds(isCheckAll ? allEmployees.map(employee => employee.id) : []);
  };

  useEffect(() => {
    if (isOpen) {
      return;
    }
  }, [isOpen]);

  const onSubmit = async (data) => {
    setIsShowSearchData(true);
    // get data when get default
    if (data && data.clearSearch) {
      await handleSearchEmployees({
        ...paramsListEmployee,
        id_exception_list: null,
        id_selected_list: null,
        no_data: metadata?.is_required_all ? 0 : 1,
      });
      return;
    }

    const paramsData = {
      name: data.name,
      from: data.from ? moment(data.from).format("YYYY-MM-DD") : "",
      to: data.to ? moment(data.to).format("YYYY-MM-DD") : "",
      work_status: data.work_status,
      role_1: data.role_1,
      job_codes: Array.isArray(data.job_codes)
        ? data.job_codes.filter(Boolean).map((item) => Number(item))
        : data.job_codes
        ? [Number(data.job_codes)]
        : [],
      department: data.department,
      role_2: data.role_2,
      position_code: data.position_code,
      employment_type_code: data.employment_type_code,
      business: data.business,
      code: data.code,
      id_selected_list: null,
      id_exception_list: null,
      department_2_codes: Array.isArray(data.department_2_codes)
        ? data.department_2_codes.filter(Boolean).map((item) => Number(item))
        : data.department_2_codes
        ? [Number(data.department_2_codes)]
        : [],
      department_3_code: data.department_3_code,
      department_4_code: data.department_4_code,
      department_5_code: data.department_5_code,
      employee_group: data.employee_group ?? null,
      no_data: 0,
    };
    if (Object.values(data).find((item) => !!item)) {
      await handleSearchEmployees({
        ...paramsListEmployee,
        ...paramsData,
        isPaging: 0,
        page: 1,
      });
      setPagination({
        ...pagination,
        page: 1,
      });
      return;
    }

    // exception list removed

    await handleSearchEmployees({
      ...paramsListEmployee,
      ...paramsData,
      id_exception_list: null,
      id_selected_list: null,
      no_data: metadata?.is_required_all ? 0 : 1,
    });
  };

  const handleSearchEmployees = async (params = {}) => {
    setParamsListEmployee({
      ...paramsListEmployee,
      ...params,
    });
    try {
      setIsLoading(true);
      const res = await triggerGetEmployees(params);
      setStoreSearchedEmployees(res?.result?.data || []);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllDataEmployees = async () => {
    try {
      startLoading(); // Global loading
      const res = await triggerGetEmployees();
      const resData = res?.result?.data || [];
      const enabledEmployees = filterOnlyEnableEmployee(resData);
      setStoreAllEmployees(enabledEmployees);
      setTotalSearchedEmployees(enabledEmployees?.length || 0);

      return resData;
    } finally {
      stopLoading();
    }
  };

  return {
    onSubmit,
    handleSearchEmployees,
    fetchAllDataEmployees,
    handleSelectAllEmployee,
  };
};

export default useSearchEmployee;
